"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
/* Wrap createSlice with stricter Name options */
/* istanbul ignore next */
const createSlice = (options) => {
    return (0, toolkit_1.createSlice)(options);
};
exports.createSlice = createSlice;
//# sourceMappingURL=toolkit.js.map